class StylesProvider {
    /**
     * @param {String} url
     * @return {HTMLLinkElement}
     */
    static create(url) {
        let stylesheet = document.createElement('link');
        stylesheet.href = url;
        stylesheet.type = 'text/css';
        stylesheet.rel = 'stylesheet';

        return stylesheet;
    }

    /**
     * @param {HTMLLinkElement} stylesheet
     * @private
     */
    static _attachToHead(stylesheet) {
        let head = document.getElementsByTagName('head').item(0);
        head.appendChild(stylesheet);
    }

    /**
     * @param {String} url
     * @return {Boolean}
     */
    static has(url) {
        return document.querySelector(`link[type="text/css"][href="${url}"]`) !== null;
    }

    /**
     * @param {String} url
     */
    static add(url) {
        if (this.has(url)) {
            return;
        }

        this._attachToHead(this.create(url));
    }
}

export {StylesProvider};
